import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { PostHogProvider } from "posthog-js/react"
import "./index.css"
import "./i18n"

const PostHogWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (import.meta.env.MODE === "development")
    return children

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_API_HOST,
        ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        debug: import.meta.env.MODE === "development",
      }}
    >
      {children}
    </PostHogProvider>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogWrapper>
      <App />
    </PostHogWrapper>
  </React.StrictMode>
)
